import {
  ADD_GOALS_ACHIEVED,
    GET_APPRAISAL_QUESTIONS,    
    GET_APPRAISEE_DETAILS,    
    GET_APPRAISEE_PERFORMANCEGOALS,    
    GET_EXPERTLEVEL,    
    GET_GOALS_ACHIEVED,    
    GET_GOALS_BY_DESIGNATION,    
    GET_POTENTIAL_LIST,    
    GET_RATING_LIST,    
    GET_TECHNICAL_CAPABILITY,    
    SAVEAPPRAISEEDETAILS_SELFREVIEW,
    SAVE_PERFORMANCEGOALS,
    SAVE_TECHNICAL_CAPABILITY,
    GET_ATTRIBUTE_LIST,
    SAVE_BEHAVIOUR_ATTRIBUTES,
    GET_BEHAVIOUR_ATTRIBUTES,
    SAVE_PERFORMANCE_LEARNING_PLAN,
    GET_PERFORMANCE_LEARNING_PLAN,
    SUBMITDATA,
    GET_REVIEW_APPRAISEE_LIST,
    GET_APPRAISAL_ENABLE_ADMIN_LIST,
    ENABLE_ALL_APPRAISEE,
    CHECK_APPRAISAL_ENABLED_STATE,
    ADD_APPRAISAL_QUESTIONS,
    UPDATE_APPRAISAL_QUESTIONS,
    DELETE_APPRAISAL_QUESTIONS,
    DELETE_GOALS_ACHIEVED,
    DELETE_PERFOMANCE_GOALS,
    DELETE_BEHAVIORAL_ATTRIBUTE_APPRAISAL,
    DELETE_TECHNICAL_CAPABILITY,
    GET_PERFOMANCE_GOALS,

    DELETE_APPRAISAL_QUESTIONS_ERROR,
  } from "../../actions/actionType";
  
  // saga call.
  export const getAppraisalQuestions = () => {
    return {
      type: GET_APPRAISAL_QUESTIONS,
    };
  };
  export const SaveAppraiseeDetailsAndSelfReview = (formData) => {
    return {
      type: SAVEAPPRAISEEDETAILS_SELFREVIEW,
      payload: formData,
    };
  };
  export const getAppraiseeDetails = (empId) => {
    return {
      type: GET_APPRAISEE_DETAILS,
      payload: empId,
    };
  };
  export const getExpertLevel = () => {
    return {
      type: GET_EXPERTLEVEL,
    };
  };
  export const AddEditGoalsAchieved = (formData) => {
    return {
      type: ADD_GOALS_ACHIEVED,
      payload : formData
    };
  };
  export const DeleteGoalsAchieved = (formData) => {
    return {
      type: DELETE_GOALS_ACHIEVED,
      payload : formData
    };
  };
  export const DeleteTechnicalCapability = (formData) => {
    return {
      type: DELETE_TECHNICAL_CAPABILITY,
      payload : formData
    };
  };
  export const DeletePerfomanceGoals = (formData) => {
    return {
      type: DELETE_PERFOMANCE_GOALS,
      payload : formData
    };
  };
  export const delErrorAppraisalQuestions = (delId) => {
    return {
      type: DELETE_APPRAISAL_QUESTIONS_ERROR,
    };
  };
  export const DeleteBehaviouralAttributeAppraisal = (formData) => {
    return {
      type: DELETE_BEHAVIORAL_ATTRIBUTE_APPRAISAL,
      payload : formData
    };
  };
  export const GetGoalsAchieved = (formData) => {
    return {
      type: GET_GOALS_ACHIEVED,
      payload : formData
    };
  };
  export const GetGoalsByDesignation = (designationId) => {
    return {
      type: GET_GOALS_BY_DESIGNATION,
       payload : designationId
    };
  };
  export const GetRatingList = () => {
    return {
      type: GET_RATING_LIST,
    };
  };
  export const SavePerformanceByGoals = (formData) => {
    return {
      type: SAVE_PERFORMANCEGOALS,
      payload: formData,
    };
  };
  export const GetPerformanceGoalsByAppraiseeId = (empId) => {
    return {
      type: GET_PERFOMANCE_GOALS,
      payload : empId
    };
  };
  export const GetPotentialsList = () => {
    return {
      type: GET_POTENTIAL_LIST,
    };
  };
  export const SaveTechinicalCapability = (formData) => {
    return {
      type: SAVE_TECHNICAL_CAPABILITY,
      payload: formData,
    };
  };
  export const GetTechnicalCapability = (empId) => {
    return {
      type: GET_TECHNICAL_CAPABILITY,
      payload : empId
    };
  };
  export const GetAttributeList = () => {
    return {
      type: GET_ATTRIBUTE_LIST,
    };
  };
  export const SaveBehaviouralAttributes = (formData) => {
    return {
      type: SAVE_BEHAVIOUR_ATTRIBUTES,
      payload: formData,
    };
  };
  export const GetBehaviouralAttributes = (empId) => {
    return {
      type: GET_BEHAVIOUR_ATTRIBUTES,
      payload: empId,
    };
  };
  export const SavePerformanceLearnningPlan = (formData) => {
    return {
      type: SAVE_PERFORMANCE_LEARNING_PLAN,
      payload: formData,
    };
  };
  export const GetPerformanceLearnningPlan = (payload) => {
    return {
      type: GET_PERFORMANCE_LEARNING_PLAN,
      payload: payload,
    };
  };
  export const GetPerformanceLearningPlanByAppraiseeId = (payload) => {
    return {
      type: GET_PERFORMANCE_LEARNING_PLAN,
      payload: payload,
    };
  };
  export const SubmitData = (payload) => {
    return {
      type: SUBMITDATA,
      payload: payload,
    };
  };
  export const GetReviewAppraiseeList = (empId) => {
    return {
      type: GET_REVIEW_APPRAISEE_LIST,
      payload: empId,
    };
  };
  export const GetAppraisalEnableList = () => {
    return {
      type: GET_APPRAISAL_ENABLE_ADMIN_LIST,
    };
  };
  export const EnableAllAppraisee = (payload) => {
    return {
      type: ENABLE_ALL_APPRAISEE,
      payload: payload,
    };
  };
  export const CheckAppraisalEnableState = (empId) => {
    return {
      type: CHECK_APPRAISAL_ENABLED_STATE,
      payload: empId,
    };
  };
 
  